/* eslint-disable react-hooks/exhaustive-deps */
/* eslint-disable security/detect-object-injection */
/* eslint-disable no-param-reassign */
import React, {
    useContext, useCallback, useState, useEffect
} from 'react';
import _ from 'lodash';
import { useModal } from '@jutro/components';
import { useTranslator } from '@jutro/locale';
import { BreakpointTrackerContext } from '@jutro/layout';
import { WizardPage, wizardProps } from '@xengage/gw-portals-wizard-react';
import { ViewModelServiceContext, ViewModelForm } from '@xengage/gw-portals-viewmodel-react';
import { useDependencies } from '@xengage/gw-portals-dependency-react';
import { useAuthentication } from '@xengage/gw-digital-auth-react';
import { useValidation } from '@xengage/gw-portals-validation-react';
import { MockUpUtil } from '@xengage/gw-portals-util-js';
import { readViewModelValue } from '@xengage/gw-jutro-adapters-react';
import { AdditionalInterestComponent } from 'premier-capability-policyjob-react';
import { useUpdateSubmissionServices, useCheckSubmissionVMDirty, validationUtil } from 'premier-capability-hooks';
import { withRouter } from 'react-router-dom';
import RVVehicleComponent from '../../components/RVVehicleComponent/RVVehicleComponent';

import presentationMetadata from './VehiclesPage.metadata.json5';
import messages from './VehiclesPage.messages';
import styles from './VehiclesPage.module.scss';
import { PremierConstants } from 'premier-constant-service';

function VehiclesPage(props) {
    const {
        showConfirm
    } = useModal();

    const { wizardData: submissionVM, updateWizardData, currentStep ,history, steps} = props;
    const viewModelService = useContext(ViewModelServiceContext);
    const breakpoint = useContext(BreakpointTrackerContext);
    const translator = useTranslator();
    const [isPageInitialised, updateIsPageInitialised] = useState(false);
    const { LoadSaveService } = useDependencies('LoadSaveService');
    const [vehicleNumberMax, setVehicleNumberMax ] = useState(0);
    const [isVinEdit, setIsVinEdit] = useState(false);
    const { updateSubmission, saveAndQuoteSubmissionService } = useUpdateSubmissionServices();
    const jobNumber = submissionVM.value?.quoteID || submissionVM.value?.jobID;
    const { isDirty } = useCheckSubmissionVMDirty(submissionVM.value);
    const { lineName } = PremierConstants;
    const {
        pageKey
    } = currentStep;
    const metadata = presentationMetadata[pageKey];

    const { authHeader } = useAuthentication();
    const {
        onValidate,
        initialValidation,
        isComponentValid,
        disregardFieldValidation
    } = useValidation('rvVehiclesPage');

    const createVehicleVM = useCallback(async () => {
        
        const accountHolder = submissionVM.baseData.accountHolder.value;
        const vehicleObj = {
            licenseState: accountHolder.primaryAddress.state,
            vehicleNo: 1,
            safetyEquipments: [],
            afterMarketAccessories : [],
            additionalInterests: []
        };
        const { _xCenter, _dtoName } = submissionVM.lobData.recVehLine.coverables.vehLocRisks;
       
        let vehicleVM = viewModelService.create(vehicleObj, _xCenter, _dtoName);
        
        const { quoteID, sessionUUID } = submissionVM.value;

        const vehicleResponseVM = await LoadSaveService.createVehicleRisk_Ext(
            jobNumber, sessionUUID, vehicleVM.value,
            authHeader
        );


        vehicleResponseVM.isValidationRequired=true;

        vehicleVM = viewModelService.create(vehicleResponseVM, _xCenter, _dtoName);

        _.set(vehicleVM.value, 'vehicleNo', 1);
        submissionVM.lobData.recVehLine.coverables.vehLocRisks.pushElement(vehicleVM);
       // _.set(submissionVM, 'lobData.recVehLine.coverables.vehLocRisks', vehicleVM.value);
       // _.set(submissionVM, 'lobData.recVehLine.coverables.vehLocRisks', vehicleVM);

       // const newSubmissionVMClone = viewModelService.clone(submissionVM);

       // eslint-disable-next-line no-secrets/no-secrets
       // updateWizardData(newSubmissionVMClone);

        updateWizardData(submissionVM);
        }, [LoadSaveService, authHeader, submissionVM, updateWizardData, viewModelService]);

    useEffect(() => {
        if (!isPageInitialised) {
            const maxNumber = (submissionVM.lobData.recVehLine.coverables.vehLocRisks.length > 0) ? _.max(submissionVM.lobData.recVehLine.coverables.vehLocRisks.value.map((vehicle) => vehicle.vehicleNo)) : 1;

            setVehicleNumberMax(maxNumber);

            const vehiclesPath = 'lobData.recVehLine.coverables.vehLocRisks';
            const vehicles = _.get(submissionVM, `${vehiclesPath}.value`);

            const newVehicles = vehicles.map((vehicle, index) => {
                const pathToCheckForMockData = `${vehiclesPath}.${index}`;
                const isLicenseNumberMocked = MockUpUtil.isValueMocked(
                    submissionVM.value,
                    'quote.recVehLine',
                    `${pathToCheckForMockData}.license`
                );
                const isVINMocked = MockUpUtil.isValueMocked(
                    submissionVM.value,
                    'quote.recVehLine',
                    `${pathToCheckForMockData}.vin`
                );
                const newVehicle = {
                    ...vehicle,
                    vin: isVINMocked ? undefined : vehicle.vin,
                    costNew: isLicenseNumberMocked
                        ? {
                            ...vehicle.costNew,
                            amount: undefined
                        }
                        : vehicle.costNew
                };

                if (isLicenseNumberMocked && newVehicle.license) {
                    delete newVehicle.license;
                }

                return newVehicle;
            });

            if (!_.isEqual(newVehicles, vehicles)) {
                _.set(submissionVM, `${vehiclesPath}.value`, newVehicles);
                updateWizardData(submissionVM);
            }

            if (_.isEmpty(vehicles)) {
                createVehicleVM();
            }

            updateIsPageInitialised(true);
        }
    }, [createVehicleVM, isPageInitialised, submissionVM, updateWizardData]);

    const removeVehicle = useCallback(
        (evt) => {
            const vehicleListPath = 'lobData.recVehLine.coverables.vehLocRisks.value';
            const currentPath = evt.path;
            const vehiclePath = currentPath.replace(/\.children\[(\d+)\]/, '.children[$1].value');
            const vehicle = _.get(submissionVM, vehiclePath);
            const vehicleList = _.get(submissionVM, vehicleListPath);
            const vehicleIndex = vehicleList.findIndex(
                (driverFromList) => _.isEqual(driverFromList, vehicle)
            );

            showConfirm({
                title: messages.removeVehicleTitle,
                message: messages.removeVehicleDescription,
                status: 'warning',
                icon: 'mi-error-outline'
            }).then(
                (results) => {
                    if (results !== 'confirm') {
                        return _.noop();
                    }

                    const newVehicleList = _.remove(vehicleList,
                        (vehicleFromList) => _.isEqual(vehicleFromList, vehicle));

                    _.set(submissionVM, newVehicleList, vehicleListPath);
                    disregardFieldValidation(`vehicle${vehicleIndex}`);
                    updateWizardData(submissionVM);

                    return true;
                }, _.noop
            );
        },
        [disregardFieldValidation, showConfirm, submissionVM, updateWizardData]
    );

    const updateAdditionalInterests = useCallback(() => {
        updateWizardData(submissionVM);
    }, [submissionVM, updateWizardData]);

    const generateOverrides = useCallback(() => {
        const vehiclePath = 'lobData.recVehLine.coverables.vehLocRisks';
        const vehicles = _.get(submissionVM, 'lobData.recVehLine.coverables.vehLocRisks.value', []);

        const overrides = vehicles && vehicles.map((vehicle, index) => {
            vehicle.isValidationRequired = true;

            let vehicleTitle = translator(messages.rvVehicleTitle);
            let vehicleNewTitle = ''
            if(vehicle.yearBuilt)
                vehicleNewTitle = vehicle.yearBuilt.toString() + ' ';
            if(vehicle.make){
                vehicleNewTitle += vehicle.make + ' ';                
            }
            if(vehicle.model){
                vehicleNewTitle += vehicle.model + ' ';                
            }

            if (vehicles.length > 1 && index !== 0) {
                vehicleTitle = `${translator(messages.rvVehicleTitleNumber)} ${index + 1}`;
            }

            return {
                [`rvDeleteVehicle${index}`]: {
                    visible: vehicles.length > 1
                },
                [`vehicleDetailsAccordionCard${index}`]: {
                    title: vehicleNewTitle.length > 1 ? vehicleNewTitle : vehicleTitle
                },
                [`rvVehicleTitle${index}`]: {
                    content: 'Vehicle Details'
                },
                [`additionalinterestcomponentId${index}`]: {
                    updateAdditionalInterests,
                    value: _.get(submissionVM, `${vehiclePath}.children[${index}]`)
                },
                [`vehicle${index}`]:{
                    updateWizardData,
                    submissionVM,
                    authHeader,
                    setIsVinEdit
                }
            };
        });

        return Object.assign({}, ...overrides);
    }, [authHeader, submissionVM, translator, updateAdditionalInterests, updateWizardData, setIsVinEdit]);


    const onNext = useCallback(async () => {
        submissionVM.lobData.recVehLine.coverables.vehLocRisks.value.map((v, index) => {
            const vehicle = v;

            vehicle.vehicleNo = (index + 1);

            return vehicle;
        })
        
        const { currentStepIndex } = props;
        const newSteps = steps.slice(currentStepIndex + 1, steps.length);

        const {jobType} = submissionVM.value.baseData;
        
        
        if(submissionVM.value.baseData.jobType === 'PolicyChange' && (newSteps.length === 1) ){
            const response = await saveAndQuoteSubmissionService('PRVRecVehLine', 'VehiclesPage', jobNumber, submissionVM.value, jobType, true);

            submissionVM.value = response.quoteResponse;
        } else{
            const response = await updateSubmission('PRVRecVehLine', 'VehiclesPage', submissionVM);

            submissionVM.value = response;
        }

        // if(!_.isUndefined(quoteResponse?.jumpLocation)){
              
        //         history.location.state.skipHandleCancel = true;  
        //         history.push({
        //             pathname: quoteResponse?.jumpLocation,
                
        //         });

        //     return false;
        // }

        // submissionVM.value = quoteResponse.quoteResponse;
        
        updateWizardData(submissionVM);

        return submissionVM;
    }, [LoadSaveService, authHeader, submissionVM, isDirty]);

    const onSave = useCallback(
        async () => {
            const subVMCopy = _.clone(submissionVM)
            const productCode = _.get(subVMCopy.value, 'baseData.productCode');

            validationUtil.unSetIsValidationReqFlag(subVMCopy.lobData.recVehLine.coverables.vehLocRisks.value, ' ')

            const lobLineName = productCode ? lineName[productCode] : '';
            
            await updateSubmission(lobLineName, 'DriversPage', subVMCopy);
                            
            return submissionVM;
        },
        [lineName, submissionVM, updateSubmission]
    );

    const overrideProps = {
        '@field': {
            showOptional: true,
            labelPosition: breakpoint === 'desktop' ? 'left' : 'top'
        },
        addVehicle: {
            disabled: !isComponentValid
        },
        rvAddAnotherVehicleContainer: {
            visible: false
        },
        ...generateOverrides()
    };

    const resolvers = {
        resolveCallbackMap: {
            onAddVehicleClick: createVehicleVM,
            onRemoveVehicle: removeVehicle,
            onValidate
        },
        resolveComponentMap: {
            additionalinterestcomponent: AdditionalInterestComponent,
            rvVehicleComponent : RVVehicleComponent
        },
        resolveClassNameMap: styles
    };

    const readValue = useCallback(
        (id, path) => readViewModelValue(metadata, submissionVM, id, path, overrideProps),
        [metadata, submissionVM, overrideProps]
    );

    if (!isPageInitialised) {
        return null;
    }

    // Temporary fix for DE2857; code should be reverted once config changes are completed
    const isDisableNext = () => submissionVM.value.baseData.jobType!== 'PolicyChange' ? !isComponentValid : false;

    return (
        <WizardPage onNext={onNext} onSave={onSave} skipWhen={initialValidation} disableNext={isDisableNext()}>
            <ViewModelForm
                uiProps={metadata}
                model={submissionVM}
                onModelChange={updateWizardData}
                overrideProps={overrideProps}
                onValidationChange={onValidate}
                resolveValue={readValue}
                callbackMap={resolvers.resolveCallbackMap}
                componentMap={resolvers.resolveComponentMap}
                classNameMap={resolvers.resolveClassNameMap}
            />
        </WizardPage>
    );
}

VehiclesPage.propTypes = wizardProps;
export default withRouter(VehiclesPage);
